<template>
  <div class="mediaReviewPhotopointSessionOverview">
    <div class="p-2 border mb-2 mr-2 text-center rounded">
      <div class="imagePlaceholderWrapper rounded mb-1">
        <img
          v-if="photoPoint"
          :src="getImage(photoPoint)"
          class="previewImage rounded"
          loading="lazy"
          style="width: 350px; height: 200px"
        />
        <ImagePlaceholderSvg
          v-else
          :height="200"
          :width="350"
          :media-preview="true"
          class="previewImage rounded w-100 h-100"
        />
      </div>
      <div>
        <label class="bold mr-2 mb-0">{{ $t("created") }}:</label>
        <span v-if="getRunDate(photoPoint)">{{
          dateTime_dateTimeSeconds(getRunDate(photoPoint))
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { dateTimeMixin } from "@/mixins/dateTimeMixin.js";

export default {
  name: "MediaReviewPhotopointSessionOverview",
  components: {
    ImagePlaceholderSvg: () =>
      import("@/components/Base/ImagePlaceholderSvg.vue"),
  },
  mixins: [dateTimeMixin],
  props: {
    photoPoint: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    getRunDate(photoPoint) {
      if (photoPoint == null) {
        return null;
      }

      return photoPoint.createDate || photoPoint.createdAt || photoPoint.startTime || photoPoint.date || null;
    },
    getImage(photoPoint) {
      if (photoPoint == null) {
        return null;
      }

      if (photoPoint.decoratedUrl) {
        return photoPoint.decoratedUrl;
      }

      if (photoPoint.imageUrl) {
        return photoPoint.imageUrl;
      }

      if (photoPoint.previewUrl) {
        return photoPoint.previewUrl;
      }

      if (photoPoint.media && photoPoint.media.preview && photoPoint.media.preview.url) {
        return photoPoint.media.preview.url;
      }

      if (photoPoint.media && photoPoint.media.hd && photoPoint.media.hd.url) {
        return photoPoint.media.hd.url;
      }

      return null;
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.imagePlaceholderWrapper {
  position: relative;
  width: 350px;
  overflow: hidden;
  height: 200px;
}
.imagePlaceholderWrapper > *:not(.itemDuration) {
  position: absolute;
  width: 100%;
  height: auto;
  min-width: auto;
  min-height: 100%;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
